export const sleep = (ms: number): Promise<void> => {
  return new Promise((resolve, _) => {
    setTimeout(() => {
      resolve()
    }, ms)
  })
}

export const getTimeSeconds = () => new Date().getTime() / 1000.0
